<!--
  The shared context blocks, to the business (DOC-89 §4; FLOW-391; DOC-89-A §3,
  FLOW-401). Absent until a block holds something or CapX adds one. One line per block — its name and the latest entry's date, or
  Nothing here yet — which opens the block in a pop-up. Nothing asks for
  anything: no tick, no count, no state word, no button on the line.
-->
@if (blocks().length > 0 || error()) {
  <section class="cbc" data-testid="client-context-blocks" aria-labelledby="cbc-title">
    <h3 id="cbc-title" class="cbc__title">Information supporting your application</h3>
    <p class="cbc__lead">
      CapX files what you send us here. If it's easier, you can add to it yourself.
    </p>

    @if (error(); as message) {
      <p class="cbc__error" role="alert">{{ message }}</p>
    }
    @if (loading() && blocks().length === 0) {
      <p class="cbc__muted">Loading…</p>
    }

    <ul class="cbc__list">
      @for (block of blocks(); track block.short_id) {
        <li>
          <button
            type="button"
            class="cbc-line"
            aria-haspopup="dialog"
            [attr.data-testid]="'client-block-' + block.short_id"
            (click)="openBlock(block)"
          >
            <app-icon name="chevron-right" [size]="16" />
            <span class="cbc-line__text">
              <span class="cbc-line__name">
                {{ block.name }}
                @if (block.no_longer_needed) {
                  <span class="cbc-line__aside">No longer needed</span>
                }
              </span>
              <span class="cbc-line__meta">
                @if (block.latest_on) {
                  {{ block.latest_on | date: 'd MMM yyyy' }}
                } @else {
                  Nothing here yet
                }
              </span>
            </span>
          </button>
        </li>
      }
    </ul>
  </section>
}
